<template>
  <modal transition="pop-out" name="new-shipper" :width="550" :height="670">
    <div class="h-10 w-full border-b border-gray-200">
      <p class="px-8 py-2 text-gray-700">Create Shipper</p>
    </div>
    <form class="rounded px-8 pt-6 pb-8 mb-4" @submit.prevent>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2">
          Name
        </label>
        <input v-model="shipper.name" class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight" type="text" placeholder="DHL Logistics">
        <p v-if="errors.includes('name')" class="text-red-500 text-xs italic">Please provide a name.</p>
      </div>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2">
          Address
        </label>
        <input v-model="shipper.address" class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight" type="text" placeholder="No 123, John Street">
        <p v-if="errors.includes('address')" class="text-red-500 text-xs italic">Please provide an Address.</p>
      </div>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2">
          Phone
        </label>
        <input v-model="shipper.phone" class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight" type="text" placeholder="090912345">
        <p v-if="errors.includes('phone')" class="text-red-500 text-xs italic">Please provide a phone number.</p>
      </div>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2">
          Countries
        </label>
        <el-select v-model="shipper.country" filterable placeholder="Please select Shipper Country" @change="getStates(shipper.country)">
          <el-option
            v-for="item in countries"
            :key="item.label"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <p v-if="errors.includes('country')" class="text-red-500 text-xs italic">Please select a country.</p>
      </div>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2">
          States
        </label>
        <el-select v-model="shipper.state" filterable placeholder="Please select Shipper Country">
          <el-option
            v-for="item in states"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <p v-if="errors.includes('state')" class="text-red-500 text-xs italic">Please select a country.</p>
      </div>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2">
          Enable
        </label>
        <el-switch v-model="shipper.status"></el-switch>
      </div>
      <div class="flex items-center justify-between">
        <el-button @click="submit" type="primary" :loading="creating">Update</el-button>
      </div>
    </form>
  </modal>
</template>

<script>
import Mixin from '../../shippers-mixins';

export default {
  name: 'Shippers',
  mixins: [Mixin],
  data() {
    return {
      creating: false,
      errors: [],
      shipper: {
        id: '',
        name: '',
        phone: '',
        state: '',
        address: '',
        country: '',
        status: true,
      },
    };
  },
  methods: {
    submit() {
      // Validate
      this.creating = true;
      this.errors = [];

      this.validation();

      if (this.errors.length === 0) {
        try {
          this.$store.dispatch('InventoryModule/Shippers/createShipper', { shipper: this.shipper });
          this.creating = false;
          this.$notify.success({
            title: 'Success',
            message: `Shipper ${this.shipper.name}'s detail has been created successfully.`,
          });
          this.$modal.hide('new-shipper');
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'An error occurred. Please try again.',
          });
          this.creating = false;
        }
      }

      this.creating = false;
    },
  },
};
</script>
